<template>
  <mds-section
    class="flyover__wrapper"
    bold
    border="none"
    :size="6"
    :title="selectedRowInfo.name"
  >
    <template #mds-section-actions>
      <mds-button
        variation="icon-only"
        icon="remove"
        @click="$emit('closeFlyover')"
      />
    </template>
    <flyover-tabs :tabs="tabs" @tabClick="changeActiveTab" />
    <slot />
  </mds-section>
</template>

<script>
import { MdsButton } from '@mds/button'
import MdsSection from '@mds/section'
import FlyoverTabs from './FlyoverTabs.vue'

export default {
  name: 'FlyoverWrapper',
  components: {
    MdsButton,
    MdsSection,
    FlyoverTabs,
  },
  props: {
    selectedRowInfo: {
      type: Object,
      default: () => ({}),
    },
    flyoverTabs: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.$emit(
      'tabClick',
      this.flyoverTabs.find((tab) => tab.isActive)
    )
  },
  data() {
    return {
      tabs: this.flyoverTabs,
    }
  },
  watch: {
    selectedRowInfo: {
      handler() {
        this.changeActiveTab(this.flyoverTabs[0])
      },
    },
  },
  methods: {
    changeActiveTab(tab) {
      this.$emit('tabClick', tab)
      this.tabs = this.tabs.map((element) => ({
        ...element,
        isActive: element.id === tab.id,
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.flyover {
  &__wrapper {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 400px;
    background-color: $mds-background-color-white;
    box-shadow: $mds-space-quarter-x $mds-space-quarter-x
      $mds-space-three-quarter-x;
    display: flex;
    flex-direction: column;

    &::v-deep [class^='mds-section__header-container'] {
      margin-bottom: 0;
      padding: $mds-space-1-and-a-half-x;
      align-items: center;
    }

    &::v-deep [class^='mds-section__title'] {
      max-width: calc(100% - 40px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: $mds-space-2-and-a-half-x;
    }

    &::v-deep [class^='mds-section__content'] {
      display: flex;
      flex-direction: column;
      flex: auto;

      > [class^='mds-tabs'] {
        padding-left: 12px;
      }

      > :last-child {
        display: flex;
        flex-direction: column;
        flex: auto;
        background-color: $mds-background-color-light-gray;
        margin: 0;
        width: 100%;
      }

      > ul {
        padding: $mds-space-1-and-a-half-x;
      }
    }
  }
}
</style>
